/**
 * Nicchia Newsletter Popup — V2 Style
 * Adapted from Halo V2 theme for Ella 7
 *
 * Two-stage animation:
 *   1) Popup fades in and scales up (newsletter-show)
 *   2) 700ms later, banner & wrapper slide in from opposite sides (show-newsletter-image)
 */

class NicchiaNewsletterPopup extends HTMLElement {
  constructor() {
    super();

    this.popup = this;
    this.timeToShow = parseInt(this.popup.getAttribute('data-delay')) || 5000;
    this.expiresDate = parseInt(this.popup.getAttribute('data-expire')) || 1;

    // Check cookie — only show if not previously dismissed
    if (this.getCookie('nicchia-newsletter-popup') === '') {
      setTimeout(() => {
        document.body.classList.add('nicchia-newsletter-show');
      }, this.timeToShow);

      setTimeout(() => {
        document.body.classList.add('nicchia-show-image');
      }, this.timeToShow + 700);
    }

    // Close button
    const closeBtn = this.querySelector('[data-close-newsletter-popup]');
    if (closeBtn) {
      closeBtn.addEventListener('click', this.setClosePopup.bind(this));
    }

    // Form submit
    const form = this.querySelector('form');
    if (form) {
      form.addEventListener('submit', this.setClosePopup.bind(this));
    }

    // Dismiss label ("No, Gracias")
    const dismissLabel = this.querySelector('[data-dismiss-popup]');
    if (dismissLabel) {
      dismissLabel.addEventListener('click', this.setClosePopup.bind(this));
    }

    // Click outside popup to close
    document.body.addEventListener('click', this.onBodyClickEvent.bind(this));

    // Overlay click
    const overlay = document.querySelector('.nicchia-popup-overlay');
    if (overlay) {
      overlay.addEventListener('click', this.setClosePopup.bind(this));
    }

    // Shopify editor support
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:select', (e) => {
        if (e.target.querySelector('nicchia-newsletter-popup')) {
          document.body.classList.add('nicchia-newsletter-show');
          setTimeout(() => {
            document.body.classList.add('nicchia-show-image');
          }, 300);
        }
      });
      document.addEventListener('shopify:section:deselect', (e) => {
        if (e.target.querySelector('nicchia-newsletter-popup')) {
          this.setClosePopup();
        }
      });
    }
  }

  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  getCookie(cname) {
    const name = cname + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  setClosePopup() {
    this.setCookie('nicchia-newsletter-popup', 'closed', this.expiresDate);
    document.body.classList.remove('nicchia-newsletter-show');
    setTimeout(() => {
      document.body.classList.remove('nicchia-show-image');
    }, 700);
  }

  onBodyClickEvent(event) {
    if (
      !this.contains(event.target) &&
      !event.target.closest('[data-open-newsletter-popup]') &&
      document.body.classList.contains('nicchia-newsletter-show')
    ) {
      this.setClosePopup();
    }
  }
}

if (!customElements.get('nicchia-newsletter-popup')) {
  customElements.define('nicchia-newsletter-popup', NicchiaNewsletterPopup);
}

/* Message popup (success/error) */
class NicchiaNewsletterMessagePopup extends HTMLElement {
  constructor() {
    super();

    const closeBtn = this.querySelector('[data-close-newsletter-message-popup]');
    if (closeBtn) {
      closeBtn.addEventListener('click', this.close.bind(this));
    }

    document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
  }

  close() {
    document.body.classList.remove('nicchia-newsletter-message-show');
  }

  onBodyClickEvent(event) {
    if (!this.contains(event.target) && document.body.classList.contains('nicchia-newsletter-message-show')) {
      this.close();
    }
  }
}

if (!customElements.get('nicchia-newsletter-message-popup')) {
  customElements.define('nicchia-newsletter-message-popup', NicchiaNewsletterMessagePopup);
}
